export default defineAppConfig({
  isGlobalDev:
    String(import.meta.env.MODE).localeCompare('development', 'en', {
      sensitivity: 'base',
    }) === 0,
});
